import script from "./Allarmi.vue?vue&type=script&setup=true&lang=js"
export * from "./Allarmi.vue?vue&type=script&setup=true&lang=js"

import "./Allarmi.vue?vue&type=style&index=0&id=4f11f3ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f11f3ca"]])

export default __exports__